import React, {useEffect, useRef} from "react";
import {Image} from "@react-three/drei"
import {Mesh} from "three";
import {CurrentTrack} from "../spotify/DataModels";
import K4Api from "../../services/K4Api";
import {config} from "../../config";
import {useFrame} from "@react-three/fiber";
import {createPixelatedImage, getNearSizeImage} from "../spotify/utils";

export interface SpotifyImageProps {
    position: [number, number, number],
    rotation: [number, number, number],
    scale: number
}

const SpotifyImageMesh: React.FC<SpotifyImageProps> = ({position, rotation, scale}) => {
    const [currentTrack, setCurrentTrack] = React.useState<CurrentTrack | null>(null);
    const [currentPixelatedImage, setCurrentPixelatedImage] = React.useState<string | null>(null);


    useEffect( () => {
        const interval = setInterval(() => {
            K4Api.getCurrentTrack().then((track) => {
                setCurrentTrack(track);
                const nearSizeImage = getNearSizeImage(track.track.images, 50);
                console.log(nearSizeImage)
                createPixelatedImage(
                    nearSizeImage.url, [64, 64], [50 * 4, 50 * 4]
                ).then((image) => {
                    setCurrentPixelatedImage(image);
                });
                console.log(currentPixelatedImage)
            }).catch((error) => {
                console.error(error);
                console.error(error.response);
            })
        }, config.k4api_spotify_check_interval);
        return () => clearInterval(interval);
    }, [])

    const ref = useRef<Mesh>(null)

    useFrame(() => {
        // ref.current?.
    })

    return (
        // <Image ref={ref} position={position} scale={scale} rotation={rotation}
        //        url={currentTrack?.track?.images ? getNearSizeImage(currentTrack.track.images, 50).url : 'https://fastly.picsum.photos/id/875/200/300.jpg?hmac=9NSoqXHP89pGlq4Sz3OgGxjx5c91YHJkcIOBFgNJ8xA'}/>
        <Image ref={ref} position={position} scale={scale} rotation={rotation}
               url={currentPixelatedImage ?? 'https://fastly.picsum.photos/id/875/200/300.jpg?hmac=9NSoqXHP89pGlq4Sz3OgGxjx5c91YHJkcIOBFgNJ8xA'}/>
    )
}

export default SpotifyImageMesh;